import { PageLayout } from "@fp/ui/components/base/page-layout/page-layout";
import { Children, type ReactNode } from "react";
import MobileNav from "./mobile-nav";

export function AdminLayout({
	hideNav = false,
	isWide = false,
	className,
	children,
}: {
	hideNav?: boolean;
	isWide?: boolean;
	className?: string;
	children: ReactNode;
}) {
	const childArray = Children.toArray(children);
	const [header, ...rest] = childArray;

	return (
		<PageLayout className={className} isWide={isWide}>
			{header}
			{rest}
			{!hideNav && <MobileNav />}
		</PageLayout>
	);
}